import React, { useEffect, useState } from "react";
import {
  DataGrid,
  GridColDef,
  GridToolbarExport,
  koKR,
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarColumnsButton,
  GridToolbarQuickFilter,
  GridFooterContainer,
  GridPreProcessEditCellProps,
} from "@mui/x-data-grid";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { koKR as corekoKR } from "@mui/material/locale";
import { Box, Button, MenuItem, Select, TextField, Typography } from "@mui/material";
import CustomPagination from "../../../component/common/CustomPagination";
import { koKRGrid } from "../../../component/common/TableKRText";
// import SwDetailDialog from "./SwDetailDialog"
import api from "../../../../API";
import { useSelector } from "react-redux";
import { SearchBackDrop } from "../../../component/common/SearchBackDrop";

function validateEmail(email: string) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

function CustomToolbar(props: any) {

  return (
    <GridToolbarContainer>
      {/* <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
       <GridToolbarExport
        csvOptions={{
          utf8WithBom: true,
        }}
      /> */}
      <Box sx={{width:"100%", display:"flex", justifyContent:"center"}}>
      {props.t_user_cnt.total_cnt > 0 &&
        <Box display="flex" sx={{alignItems: "center", borderRadius:"12px", padding:"2px"}}>
          <Box sx={{backgroundColor:"#fff",fontWeight:700,fontSize:"16px",border:"2px solid #000",borderRadius:"12px",padding:"2px 8px", marginLeft:"32px",marginRight:"32px", color:"#000"}}>전체  : <b style={{color:"red"}}>{props.t_user_cnt.total_cnt}</b> 건</Box>
          <Box display="flex" sx={{backgroundColor:"#81fd9c", alignItems: "center", borderRadius:"12px", padding:"2px"}}>
            <Box sx={{backgroundColor:"#fff",fontWeight:700,fontSize:"16px",border:"2px solid #000",borderRadius:"12px",padding:"2px 8px", marginLeft:"32px", color:"#000"}}>할당  : <b style={{color:"red"}}>{props.t_user_cnt.w_cnt}</b> 건</Box>
            <Box sx={{backgroundColor:"#fff",fontWeight:700,fontSize:"16px",border:"2px solid #000",borderRadius:"12px",padding:"2px 8px", marginLeft:"32px", color:"#9e9e9e"}}>잔여  : <b style={{color:"red"}}>{props.t_user_cnt.r_cnt}</b> 건</Box>
            <Box sx={{backgroundColor:"#fff",fontWeight:700,fontSize:"16px",border:"2px solid #000",borderRadius:"12px",padding:"2px 8px", marginLeft:"32px", marginRight:"32px", color:"#2f439c"}}>완료  : <b style={{color:"red"}}>{props.t_user_cnt.o_cnt}</b> 건</Box>
          </Box>
          <Box sx={{backgroundColor:"#fff",fontWeight:700,fontSize:"16px",border:"2px solid #000",borderRadius:"12px",padding:"2px 8px", marginLeft:"32px", color:"#2f9c34"}}>적합  : <b style={{color:"red"}}>{props.t_user_cnt.y_cnt}</b> 건</Box>
          <Box sx={{backgroundColor:"#fff",fontWeight:700,fontSize:"16px",border:"2px solid #000",borderRadius:"12px",padding:"2px 8px", marginLeft:"32px", color:"#e42828"}}>부적합  : <b style={{color:"red"}}>{props.t_user_cnt.n_cnt}</b> 건</Box>
          <Box sx={{backgroundColor:"#fff",fontWeight:700,fontSize:"16px",border:"2px solid #000",borderRadius:"12px",padding:"2px 8px", marginLeft:"32px", color:"#d8ab59"}}>반려  : <b style={{color:"red"}}>{props.t_user_cnt.b_cnt}</b> 건</Box>
        </Box>
      }
      </Box>
      <Box sx={{width:"100%", display:"flex", justifyContent:"center"}}>
        
      {props.user_cnt.total_cnt > 0 &&
        <Box display="flex" sx={{alignItems: "center"}}>
          <Box sx={{backgroundColor:"#fff",fontWeight:700,fontSize:"16px",borderRadius:"12px",padding:"2px 8px", marginLeft:"32px", color:"#3e36a5"}}>
            {props.swWorkers.length > 0 && props.swWorkers.map((worker:any) => 
              (props.worker == worker.user_id && worker.name+"("+worker.user_id+")")
            )}
          </Box>
          <Box sx={{fontWeight:700,fontSize:"16px",border:"2px solid #6757f8",borderRadius:"12px",padding:"2px 8px", marginLeft:"32px", color:"#000"}}>할당  : <b style={{color:"red"}}>{props.user_cnt.w_cnt}</b> 건</Box>
          <Box sx={{fontWeight:700,fontSize:"16px",border:"2px solid #6757f8",borderRadius:"12px",padding:"2px 8px", marginLeft:"32px", color:"#2f439c"}}>완료  : <b style={{color:"red"}}>{props.user_cnt.o_cnt}</b> 건</Box>
          <Box sx={{fontWeight:700,fontSize:"16px",border:"2px solid #6757f8",borderRadius:"12px",padding:"2px 8px", marginLeft:"32px", color:"#9e9e9e"}}>미작업  : <b style={{color:"red"}}>{props.user_cnt.r_cnt}</b> 건</Box>
          <Box sx={{fontWeight:700,fontSize:"16px",border:"2px solid #6757f8",borderRadius:"12px",padding:"2px 8px", marginLeft:"32px", color:"#2f9c34"}}>적합  : <b style={{color:"red"}}>{props.user_cnt.y_cnt}</b> 건</Box>
          <Box sx={{fontWeight:700,fontSize:"16px",border:"2px solid #6757f8",borderRadius:"12px",padding:"2px 8px", marginLeft:"32px", color:"#e42828"}}>부적합  : <b style={{color:"red"}}>{props.user_cnt.n_cnt}</b> 건</Box>
          <Box sx={{fontWeight:700,fontSize:"16px",border:"2px solid #6757f8",borderRadius:"12px",padding:"2px 8px", marginLeft:"32px", color:"#d8ab59"}}>반려  : <b style={{color:"red"}}>{props.user_cnt.b_cnt}</b> 건</Box>
        </Box>
      }
      </Box>

      <Box display="flex" sx={{marginLeft: "auto", alignItems: "center"}}>

        <Box>
          <Box sx={{fontWeight:700, marginLeft:"8px", color:"#2f9c34"}}>총 건수 :{props.totalCount ? props.totalCount : "0"} 건</Box>
          <Box sx={{fontWeight:700, marginLeft:"8px", color:"#000"}}>선택 :{props.selectCheckCnt ? props.selectCheckCnt : "0"} 개</Box>
        </Box>

        <Box sx={{marginLeft:"8px", color:"#1976d2"}}>정렬</Box>
        <Select id="order" value={props.order} onChange={(e)=>props.setOrder(e.target.value)} sx={{width:"94px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
          <MenuItem dense value={"asc"}>처음</MenuItem>
          <MenuItem dense value={"desc"}>최신</MenuItem>
        </Select>

        <Box sx={{marginLeft:"8px", color:"#1976d2"}}>주제분류</Box>
        <Select id="topic_cd" value={props.topic_cd} onChange={(e)=>props.setTopic_cd(e.target.value)} sx={{width:"150px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
          <MenuItem dense value={"모두"}>모두</MenuItem>
          <MenuItem dense value={"101"}>문화,예술,교육</MenuItem>
          <MenuItem dense value={"102"}>역사,지리,관광</MenuItem>
          <MenuItem dense value={"103"}>스포츠,기타</MenuItem>
          <MenuItem dense value={"204"}>사회,산업</MenuItem>
          <MenuItem dense value={"205"}>정치,경제</MenuItem>
          <MenuItem dense value={"206"}>과학,의학</MenuItem>
          <MenuItem dense value={"307"}>관습,의례</MenuItem>
          <MenuItem dense value={"408"}>일상생활,음식</MenuItem>
        </Select>

        <Box sx={{marginLeft:"8px", color:"#1976d2"}}>Instruction</Box>
        <Select id="instruction_yn" value={props.instruction_yn} onChange={(e)=>props.setInstruction_yn(e.target.value)} sx={{width:"124px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
          <MenuItem dense value={"모두"}>모두</MenuItem>
          <MenuItem dense value={"Y"}>사용가능</MenuItem>
          <MenuItem dense value={"None"}>미분류</MenuItem>
        </Select>

        <Box sx={{marginLeft:"8px", color:"#1976d2"}}>가공</Box>
        <Select id="isp_yn" value={props.prc_yn} onChange={(e)=>props.setPrc_yn(e.target.value)} sx={{width:"134px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
          <MenuItem dense value={"모두"}>모두</MenuItem>
          <MenuItem dense value={"Y"}>적합</MenuItem>
          <MenuItem dense value={"N"}>부적합</MenuItem>
          <MenuItem dense value={"1"}>미분류</MenuItem>
          <MenuItem dense value={"YN"}>작업완료(적합+부적합)</MenuItem>
        </Select>

        <Box sx={{marginLeft:"8px", color:"#1976d2"}}>검수</Box>
        <Select id="isp_yn" value={props.isp_yn} onChange={(e)=>props.setIsp_yn(e.target.value)} sx={{width:"134px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
          <MenuItem dense value={"모두"}>모두</MenuItem>
          <MenuItem dense value={"Y"}>적합</MenuItem>
          <MenuItem dense value={"N"}>부적합</MenuItem>
          <MenuItem dense value={"0"}>미분류</MenuItem>
          <MenuItem dense value={"R"}>반려</MenuItem>
          <MenuItem dense value={"YN"}>작업완료(적합+부적합)</MenuItem>
        </Select>
        {/* <Box sx={{marginLeft:"8px", color:"#1976d2"}}>소음파일</Box>
        <Select id="vn_yn" value={props.vn_yn} onChange={(e)=>props.setVn_yn(e.target.value)} sx={{width:"134px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
          <MenuItem dense value={"모두"}>모두</MenuItem>
          <MenuItem dense value={"Y"}>있음</MenuItem>
          <MenuItem dense value={"N"}>없음</MenuItem>
        </Select> */}

        <Box sx={{marginLeft:"8px", color:"#1976d2"}}>IDX</Box>
        <TextField size="small" id="col_pk" value={props.col_pk} onChange={(e)=>props.setCol_pk(e.target.value)} sx={{width:"90px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}} />

        <Box sx={{marginLeft:"8px", color:"#1976d2"}}>워커</Box>
        <Select id="order" value={props.worker} onChange={(e)=> {props.setWorker(e.target.value);}} sx={{width:"200px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
          <MenuItem dense value={"모두"}>모두</MenuItem>
          {props.swWorkers.length > 0 && props.swWorkers.map((worker:any) => 
            <MenuItem key={worker} dense value={worker.user_id}>{worker.name}({worker.user_id})</MenuItem>
          )}
        </Select>

        {/* <Box sx={{marginLeft:"8px", color:"#1976d2"}}>워커ID</Box>
        <TextField size="small" id="worker" value={props.worker} onChange={(e)=>props.setWorker(e.target.value)} sx={{width:"90px",height: "40px", marginLeft: "8px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}} /> */}
        <Button variant="contained" sx={{marginLeft:"8px"}} onClick={()=>{props.setWorkerParam(); props.setColPkParam();}}>검색</Button>
        {props.adminRole && <Button variant="contained" sx={{marginLeft:"4px",backgroundColor:"#2f9c34"}} onClick={()=>{props.swListDown(); }}>엑셀</Button>}
      </Box>
      <Box display="flex" sx={{marginLeft: "auto", alignItems: "center"}}>
        <Box sx={{marginLeft:"8px", color:"#1976d2"}}>시작일(검수)</Box>
          <TextField sx={{marginLeft: "8px",fontSize:"8px"}} id="isp1_date_start" name="isp1_date_start" size="small" type="date"
                    value={props.isp_s_date} onChange={(e)=>props.setIsp_s_date(e.target.value)}
          // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
            InputProps={{
              style: {width: "150px", height:"30px", fontSize:"14px"},
              inputProps: { 
                spellCheck: "false" // spellcheck를 false로 설정
              },
            }}
          />

          <Box sx={{marginLeft:"8px", color:"#1976d2"}}>종료일(검수)</Box>
          <TextField sx={{marginLeft: "8px",fontSize:"8px"}} id="isp1_date_end" name="isp1_date_end" size="small" type="date"
                    value={props.isp_e_date} onChange={(e)=>props.setIsp_e_date(e.target.value)}
          // value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
            InputProps={{
              style: {width: "150px", height:"30px", fontSize:"14px"},
              inputProps: { 
                spellCheck: "false" // spellcheck를 false로 설정
              },
            }}
          />
      </Box>
      <GridToolbarQuickFilter sx={{ marginLeft: "16px" }} />
      {/* <GridToolbarQuickFilter /> */}
    </GridToolbarContainer>
  );
}

const theme = createTheme(
  {
    palette: {
      primary: { main: "#1976d2" },
    },
    typography: {
      fontFamily: "Gmarket"
    }
  },
  koKR,
  corekoKR
);

export interface SwTransData{
  idx : number;
  crw_idx : number;
  topic_cd : string;
  data_type_cd : string;
  created_date : string;
  seq : string;
  mgm_pk : string;
  issue_date : string;
  writer_ko : string;
  writer_sw : string;
  copyrighter_ko : string;
  copyrighter_sw : string;
  org_ext : string;
  data_src : string;

  url: string;
  kwd_sw: string;
  kwd_ko: string;
  kwd_en: string;
  title_sw: string;
  title_ko: string;
  title_en: string;
  text_sw: string;
  text_ko: string;
  text_en: string;

  wrd_cnt : string;
  file_size : string;
  
  prc_json : string;
  prc_yn : string;
  prc_date : string;
  
  isp1_user : string;
  isp1_yn : string;
  isp1_date : string;
  isp1_rsn : string;
  isp1_rsn_cd : string;
  
  isp2_user : string;
  isp2_yn : string;
  isp2_date : string;
  isp2_rsn : string;
  
  ins_date : string;

  instruction_yn : string;
}

export interface pageInfoType {
  current_page: number;
  total_pages: number;
}

const EvKnTableList = () => {

  const [page, setPage] = useState(1);

  const [totalCount, setTotalCount] = useState(0);
  const [selectCheckCnt , setSelectCheckCnt] = useState(0)

  const handleSelectionModelChange = (ids:any) => {
    setSelectCheckCnt(ids.length)
  };

  const [prc_yn, setPrc_yn] = useState('모두');
  const [isp_yn, setIsp_yn] = useState('모두');
  const [instruction_yn, setInstruction_yn] = useState('모두');
  const [worker, setWorker] = useState('모두');
  const [col_pk, setCol_pk] = useState('');
  const [order, setOrder] = useState('desc');

  const [topic_cd, setTopic_cd] = useState('모두');

  const [p_worker, setP_worker] = useState('');
  const [p_col_pk, setP_col_pk] = useState('');

  const [isp_s_date, setIsp_s_date] = useState('');
  const [isp_e_date, setIsp_e_date] = useState('');

  const [p_isp_s_date, setP_isp_s_date] = useState('');
  const [p_isp_e_date, setP_isp_e_date] = useState('');

  const [user_id, setUser_id] = useState('모두');
  const [swWorkers, setSwWorkers] = useState<any[]>([])

  const [t_user_cnt, setT_user_cnt] = useState([])
  const [user_cnt, setUser_cnt] = useState([])

  const setWorkerParam = () => {
    setP_worker(worker);
    setP_isp_s_date(isp_s_date);
    setP_isp_e_date(isp_e_date);
    getWorkerInfo(worker,isp_s_date,isp_e_date)
  }

  const setColPkParam = () => {
    setP_col_pk(col_pk);
  }

  const [rows, setRows] = useState([]);
  const [rowDetail, setRowDetail] = useState<SwTransData>({
    idx : -1,
    crw_idx : -1,
    topic_cd : "",
    data_type_cd : "",
    created_date : "",
    seq : "",
    mgm_pk : "",
    issue_date : "",
    writer_ko : "",
    writer_sw : "",
    copyrighter_ko : "",
    copyrighter_sw : "",
    org_ext : "",
    data_src : "",

    url: "",
    kwd_sw: "",
    kwd_ko: "",
    kwd_en: "",
    title_sw: "",
    title_ko: "",
    title_en: "",
    text_sw: "",
    text_ko: "",
    text_en: "",

    wrd_cnt : "",
    file_size : "",
    
    prc_json : "",
    prc_yn : "",
    prc_date : "",
    
    isp1_user : "",
    isp1_yn : "",
    isp1_date : "",
    isp1_rsn : "",
    isp1_rsn_cd : "",
    
    isp2_user : "",
    isp2_yn : "",
    isp2_date : "",
    isp2_rsn : "",
    
    ins_date : "",
    instruction_yn: "",
  });

  // api 사용자 정보에서 페이지 정보를 담을 state
  const [pagination, setPagination] = useState<pageInfoType | undefined>(
    undefined
  );

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;


  let adminRole = auth.user.roles.some((obj:any) => ['ADMIN'].includes(obj.role));

  const getSwIspWorkerList = async () => {
    setBackdrop(true)
    var result = await api.get("/gncWorkerList", {
      // params: {email:email,page:page,instruction_yn:instruction_yn}
      params: {email:email,role:'TZA_ISP'}
    });
    // console.log("result.data", result.data);
    let swWorkList:any[] = []
    var datas = result.data.datas.map((worker:any) => {
      // // console.log(worker.name, worker.roles[0].user_id)
      swWorkList.push({"name":worker.name,"user_id": worker.roles[0].user_id})
    })

    // console.log('swWorkList',swWorkList)
    setSwWorkers(swWorkList)
    setBackdrop(false)
  }

  const getWorkerInfo = async (user_id:string,p_isp_s_date:string,p_isp_e_date:string) => {
    // console.log(user_id,'정보가져오기')
    var result = await api.get("/swIspWorker-info", {
      // params: {email:email,page:page,instruction_yn:instruction_yn}
      params: {email:email,isp1_user:user_id,p_isp_s_date:p_isp_s_date,p_isp_e_date:p_isp_e_date}
    });
    // console.log("result.data", result.data.datas);
    if(user_id == ""){
      setT_user_cnt(result.data.datas[0])
    }else{
      setUser_cnt(result.data.datas[0])
    }
    
    
  }
  
  const getEvknList = async (order:string,prc_yn:string,isp_yn:string,worker:string,topic_cd:string) => {
    setBackdrop(true)
    var result = await api.get("/evknList", {
      // params: {email:email,page:page,instruction_yn:instruction_yn}
      params: {email:email,order:order,page:page,prc_yn:(prc_yn ? prc_yn: "모두"),isp_yn:(isp_yn ? isp_yn: "모두"),worker:(worker != "모두" ? worker: ""),col_pk:(p_col_pk ? p_col_pk: ""),p_isp_s_date:p_isp_s_date,p_isp_e_date:p_isp_e_date,topic_cd:topic_cd}
    });
    // console.log("result.data", result.data);
    setBackdrop(false)
    var datas = result.data.datas.map((data: any, idx: any) => {
      return {
        idx : data.idx,
        crw_idx : data.crw_idx,
        topic_cd : data.topic_cd,
        data_type_cd : data.data_type_cd,
        created_date : data.created_date,
        seq : data.seq,
        mgm_pk : data.mgm_pk,
        issue_date : data.issue_date,
        writer_ko : data.writer_ko,
        writer_sw : data.writer_sw,
        copyrighter_ko : data.copyrighter_ko,
        copyrighter_sw : data.copyrighter_sw,
        org_ext : data.org_ext,
        data_src : data.data_src,

        url: data.url,
        kwd_sw: data.kwd_sw,
        kwd_ko: data.kwd_ko,
        kwd_en: data.kwd_en,
        title_sw: data.title_sw,
        title_ko: data.title_ko,
        title_en: data.title_en,
        text_sw: data.text_sw,
        text_ko: data.text_ko,
        text_en: data.text_en,

        wrd_cnt : data.wrd_cnt,
        file_size : data.file_size,
        
        prc_json : data.prc_json,
        prc_yn : data.prc_yn,
        prc_date : data.prc_date,
        
        isp1_user : data.isp1_user,
        isp1_yn : data.isp1_yn,
        isp1_date : data.isp1_date,
        isp1_rsn : data.isp1_rsn,
        isp1_rsn_cd : data.isp1_rsn_cd,
        
        isp2_user : data.isp2_user,
        isp2_yn : data.isp2_yn,
        isp2_date : data.isp2_date,
        isp2_rsn : data.isp2_rsn,
        
        ins_date : data.ins_date,
        instruction_yn: data.instruction_yn,
      };
    });

    // console.log('sample list')

    // table에 넣을 rows 데이터 state에 저장
    setRows(datas);
    // pagination에 넣을 api data 페이지 정보를 state에 저장
    setPagination(result.data.pagination);
    // console.log('result.data.pagination.total_count',result.data.pagination)
    setTotalCount(result.data.pagination.total_count);

    if(worker != "모두" && worker != ""){
      getWorkerInfo(worker,p_isp_s_date,p_isp_e_date)
    }
    else{
      getWorkerInfo("",p_isp_s_date,p_isp_e_date)
    }

  };

  const swListDown = async () =>{

    setBackdrop(true)
    var response = await api.get("/swListDown", {
      params: {email:email,order:order,page:page,prc_yn:(prc_yn ? prc_yn: "모두"),isp_yn:(isp_yn ? isp_yn: "모두"),worker:(worker != "모두" ? worker: ""),col_pk:(p_col_pk ? p_col_pk: ""),p_isp_s_date:p_isp_s_date,p_isp_e_date:p_isp_e_date,topic_cd:topic_cd},
      responseType: 'arraybuffer'
    });

    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = URL.createObjectURL(blob);

    setBackdrop(false)
    // 다운로드 링크 생성
    const link = document.createElement('a');
    link.href = url;
    link.download = '스와힐리어_리스트_다운로드.xlsx';  // 다운로드 파일 이름 설정
    document.body.appendChild(link);

    // 다운로드 링크를 클릭하여 파일 다운로드
    link.click();

    // 다운로드 후에는 생성한 링크와 Blob 객체를 해제
    URL.revokeObjectURL(url);
    document.body.removeChild(link);
  };

  useEffect(() => {
    getSwIspWorkerList();
    getEvknList(order,prc_yn,isp_yn,p_worker,topic_cd);
  }, [prc_yn,isp_yn,page,order,p_worker,p_col_pk,p_isp_s_date,p_isp_e_date,topic_cd]);

  // 팝업 관리 state
  const [dialogOpen, setDialogOpen] = useState(false);

  const goDetail = (data: any) => {
    // console.log("goDetail", data);
    setRowDetail(data);
    setDialogOpen(true);
  };

  const goPage = (clickPage: any) => {
    setPage(clickPage);
  };

  function CustomFooter() {
    return (
      <GridFooterContainer sx={{ display: "flex", justifyContent: "center" }}>
        {pagination !== undefined ? (
          <CustomPagination pagination={pagination} goPage={goPage} />
        ) : ""}
      </GridFooterContainer>
    );
  }

  const columns: GridColDef[] = [
    { field: "idx", headerName: "idx", headerAlign: "center", width: 84,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>idx</Box>
      )
    },
    { field: "bmk_pk", headerName: "관리PK", headerAlign: "center", width: 160,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>관리PK</Box>
      ),
      renderCell: (params:any) => (
        <Box sx={{fontWeight:600, fontSize:"12px", cursor:"pointer"}}>{params.value}</Box>
      ),
    },
    { field: "topic_cd", headerName: "주제분류", headerAlign: "center", width: 120,
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>주제분류</Box>
      ),
      renderCell: (params:any) => (
        <Box sx={{fontWeight:600, fontSize:"12px", cursor:"pointer"}}>
          {
            (params.value == "101" ?  "문화,예술,교육"
            : (params.value == "102" ? "역사,지리,관광"
              : (params.value == "103" ? "스포츠,기타"
                : (params.value == "204" ? "사회,산업"
                  : (params.value == "205" ? "정치,경제"
                    : (params.value == "206" ? "과학,의학"
                      : (params.value == "307" ? "관습,의례"
                        : (params.value == "408" ? "일상생활,음식"
                          : "-")))))))
            )
          }
        </Box>
      ),
    },
    {
      field: "prc_yn", headerName: "가공결과", headerAlign: "center", headerClassName: "header-style", width: 120,
      preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
        const isValid = validateEmail(params.props.value);
        return { ...params.props, error: !isValid };
      },
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>가공결과</Box>
      ),
      renderCell: (params:any) => (
        <Box sx={{color:"#fff"}}>
          <Button size="small" sx={{height:"25px", color:"#fff", backgroundColor: (params.value === "N" ? "red" : (params.value === "Y" ? "#498ad5" :(params.value === "R" ? "#ef891f" : "#bbb")))}}>
            {(params.value === "N" ? "부적합" : (params.value === "Y" ? "적합" :(params.value === "R" ? "반려" :"미분류")))}
          </Button>  
        </Box>
      ),
    },
    {
      field: "isp1_user", headerName: "검수자", headerAlign: "center", headerClassName: "header-style", width: 120,
      preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
        const isValid = validateEmail(params.props.value);
        return { ...params.props, error: !isValid };
      },
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>검수자</Box>
      ),
      renderCell: (params:any) => (
        <Box sx={{fontWeight:600, fontSize:"12px", cursor:"pointer"}}>{params.value.replace('None','-')}</Box>
      ),
    },
    {
      field: "isp1_yn", headerName: "검수결과", headerAlign: "center", headerClassName: "header-style", width: 120,
      preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
        const isValid = validateEmail(params.props.value);
        return { ...params.props, error: !isValid };
      },
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>검수결과</Box>
      ),
      renderCell: (params:any) => (
        <Box sx={{color:"#fff"}}>
          <Button size="small" sx={{height:"25px", color:"#fff", backgroundColor: (params.value === "N" ? "red" : (params.value === "Y" ? "#498ad5" :(params.value === "R" ? "#ef891f" : "#bbb")))}}>
            {(params.value === "N" ? "부적합" : (params.value === "Y" ? "적합" :(params.value === "R" ? "반려" :"미분류")))}
          </Button>  
        </Box>
      ),
    },
    {
      field: "isp1_rsn_cd", headerName: "부적합코드", headerAlign: "center", headerClassName: "header-style", width: 170,
      preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
        const isValid = validateEmail(params.props.value);
        return { ...params.props, error: !isValid };
      },
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>부적합코드</Box>
      ),
      renderCell: (params:any) => (
        <Box sx={{fontWeight:600, fontSize:"12px", cursor:"pointer"}}>
          {params.value.replace('None','-')}
          {
            (params.value == "01" ?  ".탄자니아와 관련없는 내용"
            : (params.value == "02" ? ".원문 품질 부적합"
              : (params.value == "03" ? ".한국어/영어 부적합"
                : (params.value == "04" ? ".한국어 부적합"
                  : (params.value == "05" ? ".영어 부적합"
                    : (params.value == "09" ? ".직접입력"
                      : "")))))
            )
          }
          </Box>
      ),
    },
    {
      field: "isp1_date", headerName: "검수일자", headerAlign: "center", headerClassName: "header-style", width: 150, type: "date",
      preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
        const isValid = validateEmail(params.props.value);
        return { ...params.props, error: !isValid };
      },
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>검수일자</Box>
      ),
      renderCell: (params:any) => (
        <Box sx={{fontWeight:600, fontSize:"12px", cursor:"pointer"}}>{params.value}</Box>
      ),
    },
    {
      field: "isp1_rsn", headerName: "검수비고", headerAlign: "center", headerClassName: "header-style", width: 300,
      preProcessEditCellProps: (params: GridPreProcessEditCellProps) => {
        const isValid = validateEmail(params.props.value);
        return { ...params.props, error: !isValid };
      },
      renderHeader: (params: any) => (
        <Box sx={{width:"100%",justifyContent: "center", display: "flex",backgroundColor:"#95b1d1", border: "3px solid #95b1d1", borderRadius: "4px", height:"16px", alignItems: "center", color:"#fff", padding:"0px 12px", fontWeight:700}}>검수비고</Box>
      ),
      renderCell: (params:any) => (
        <Box sx={{fontWeight:600, fontSize:"12px", cursor:"pointer"}}>{params.value.replace('None','-')}</Box>
      ),
    },
    
  ];

  const [backdrop, setBackdrop] = useState<boolean>(false)

  return (
    <Box
      sx={{
        width: "100%",
        "& .MuiDataGrid-cell--editing": {
          bgcolor: "rgb(255,215,115, 0.19)",
          color: "#1a3e72",
          "& .MuiInputBase-root": {
            height: "100%",
          },
        },
        "& .Mui-error": {
          bgcolor: (theme) =>
            `rgb(126,10,15, ${theme.palette.mode === "dark" ? 0 : 0.1})`,
          color: (theme) =>
            theme.palette.mode === "dark" ? "#ff4343" : "#750f0f",
        },
        
        ".css-1e2bxag-MuiDataGrid-root .MuiDataGrid-cell--textLeft": {justifyContent : "center"},
        ".css-1e2bxag-MuiDataGrid-root .MuiDataGrid-columnHeader--sortable": {padding : "16px"},
        ".MuiDataGrid-cellContent": {fontSize : "12px", cursor:"pointer"},
      }}
    >
      <ThemeProvider theme={theme}>
        <Box sx={{ width: "100%", marginLeft:"8px" }}><h3>LLM 성능평가데이터(지식)</h3></Box>
        <Box sx={{ height: "600px", width: "100%",position:"relative" }}>
          {backdrop && ( <SearchBackDrop/> )}
          <DataGrid
            editMode="row"
            rows={rows}
            columns={columns}
            onRowDoubleClick={(e) => goDetail(e.row)}
            checkboxSelection
            onSelectionModelChange={handleSelectionModelChange}
            pageSize={100}
            rowHeight={38}
            components={{ Toolbar: CustomToolbar, Footer: CustomFooter}}
            componentsProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 500 },

                totalCount:totalCount,
                selectCheckCnt: selectCheckCnt,

                prc_yn: prc_yn,
                setPrc_yn: setPrc_yn,

                isp_yn: isp_yn,
                setIsp_yn: setIsp_yn,

                isp_s_date: isp_s_date,
                setIsp_s_date: setIsp_s_date,
                isp_e_date: isp_e_date,
                setIsp_e_date: setIsp_e_date,

                order: order,
                setOrder: setOrder,

                worker: worker,
                setWorker: setWorker,
                setWorkerParam: setWorkerParam,

                sources_id: col_pk,
                setCol_pk: setCol_pk,
                setColPkParam: setColPkParam,

                swListDown: swListDown,

                adminRole: adminRole,

                swWorkers: swWorkers,

                t_user_cnt: t_user_cnt,
                user_cnt: user_cnt,

                topic_cd: topic_cd,
                setTopic_cd: setTopic_cd,

              },
            }}
            getRowId={(row) => row.idx}
            localeText={koKRGrid}
            experimentalFeatures={{ newEditingApi: true }}
            onFilterModelChange={(e) => console.log('이벤트!!!',e)}
            // sx={{cursor:"pointer"}}
          />
        </Box>
      </ThemeProvider>
      {/* {dialogOpen == true ? (
        <SwDetailDialog
          // dialogOpen={dialogOpen}
          setDialogOpen={setDialogOpen}
          rowDetail={rowDetail}
          setRowDetail={setRowDetail}
          getEvknList={getEvknList}
          p_order={order}
          p_instruction_yn={instruction_yn}
          p_worker={p_worker}
          p_isp_s_date={p_isp_s_date}
          p_isp_e_date={p_isp_e_date}
          prc_yn={prc_yn}
          isp_yn={isp_yn}
          p_topic_cd={topic_cd}
        />
      ) : ""} */}
    </Box>
  );
};
export default EvKnTableList;
